import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index.vue'
import store from '@/store'
import {getCode} from '@/utils/wx'
import { getConfig } from '@/utils/common.js'
Vue.use(Router)

const router  = new Router({
	mode: 'history',
	// mode: 'hash',
	base: process.env.BASE_URL,
	routes: [
		{
      path: '/',
			redirect: '/index'
		},
		{   // 首页
			path: '/index',
			name: 'index',
			component: Index,
			meta: {
				title: "首页",
				tab: 0,
				keepAlive: true,
				Backcolor: true, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				alive: true
			}
		},
		{
			// 选择考试类别专业
			path: '/chooseexam',
			name: 'ChooseExam',
			component: () => import('@/views/ChooseExam.vue'),
			meta: {
				title: "选择考试类别专业",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{   // 积分商城
			path: '/shop',
			name: 'shop_index',
			component: () => import('@/views/shop/Index.vue'),
			meta: {
				title: "积分商城",
				tab: 1,
				keepAlive: true,
				Backcolor: true,
				noNavigation:true,  //设置导航
				showAppPaddB: true
			}
		},
		{   // 商品详情
			path: '/shopdetail',
			name: 'shopDetail',
			component: () => import('@/views/shop/shopDetail.vue'),
			meta: {
				title: "",
				keepAlive: false,
				Backcolor: true,
				noNavigation:true,  //设置导航
				showAppPaddB: true
			}
		},
		{  // 消息
			path: '/news',
			name: 'news_index',
			component: () => import('@/views/news/Index.vue'),
			meta: {
				title: "消息",
				tab: 2,
				keepAlive: true,
				Backcolor:true,
				noNavigation:true,  //设置导航
				showAppPaddB: true
			}
		},
		{  // 消息详情
			path: '/newsdetail',
			name: 'newsDetail',
			component: () => import('@/views/news/newsDetail.vue'),
			meta: {
				title: "消息",
				tab: 2,
				keepAlive: false,
				Backcolor:false,
				noNavigation:true,  //设置导航
				showAppPaddB: false,
				appHeight: true
			}
		},
		{   // 个人中心
			path: '/member',
			name: 'member_index',
			component: () => import('@/views/member/Index.vue'),
			meta: {
				title: "个人中心",
				tab: 3,
				keepAlive: true,
				noNavigation:true,  //设置导航
				showAppPaddB: true,
				alive: true
			}
		},
		{
			// 会员购买
			path: '/vip',
			name: 'vip',
			component: () => import('@/views/vip/index.vue'),
			meta: {
				title: "会员购买",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{
			// 购买真题试卷
			path: '/buytest',
			name: 'vip',
			component: () => import('@/views/buyTest/index.vue'),
			meta: {
				title: "购买试卷",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{   // 登录
			path: '/login',
			name: 'login',
			component: () => import('@/views/Login.vue'),
			meta: {
				title: "登录",
				keepAlive: false,
				noNavigation:true,  //设置导航
				showAppPaddB: false
			}
		},
		
		{
			// 添加计划
			path: '/addplan',
			name: 'addPlan',
			component: () => import('@/views/word/addPlan.vue'),
			meta: {
				title: "添加计划",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},

		{
			// 单词本
			path: '/wordbook',
			name: 'wordBook',
			component: () => import('@/views/word/wordBook.vue'),
			meta: {
				title: "单词本",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 调整计划
			path: '/adjustplan',
			name: 'adjustPlan',
			component: () => import('@/views/word/adjustPlan.vue'),
			meta: {
				title: "调整计划",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 切换计划
			path: '/switchplan',
			name: 'switchPlan',
			component: () => import('@/views/word/switchPlan.vue'),
			meta: {
				title: "切换计划",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 背单词
			path: '/reciteWord',
			name: 'reciteWord',
			component: () => import('@/views/word/reciteWord.vue'),
			meta: {
				title: "背单词",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 背单词日历
			path: '/calendar',
			name: 'calendar',
			component: () => import('@/views/word/calendar.vue'),
			meta: {
				title: "背单词日历",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 每日一练
			path: '/practicelist',
			name: 'practiceList',
			component: () => import('@/views/practice/index.vue'),
			meta: {
				title: "每日一练",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{   // 每日一练题
			path: '/startpractice',
			name: 'startPractice',
			component: () => import('@/views/practice/startPractice.vue'),
			meta: {
				title: "每日一练",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: true
			}
		},

		{   // 每日一练-答题卡
			path: '/card',
			name: 'card',
			component: () => import('@/views/practice/card.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: true
			}
		},

		{   // 每日一练-答题报告
			path: '/report',
			name: 'report',
			component: () => import('@/views/practice/report.vue'),
			meta: {
				title: "答题报告",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: false
			}
		},

		{   // 每日一练-查看解析
			path: '/analysis',
			name: 'analysis',
			component: () => import('@/views/practice/analysis.vue'),
			meta: {
				title: "查看解析",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
			}
		},

		{   // 每日一练-解析答题卡
			path: '/practiceanalysiscard',
			name: 'practiceAnalysisCard',
			component: () => import('@/views/practice/practiceAnalysisCard.vue'),
			meta: {
				title: "查看解析",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
			}
		},


		{
			// 我的练习
			path: '/mypracticelist',
			name: 'myPracticeList',
			component: () => import('@/views/practice/myPracticeList.vue'),
			meta: {
				title: "我的练习",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},
		{
			// 考点刷题-考点列表
			path: '/testplace',
			name: 'testPlace',
			component: () => import('@/views/testQuset/testPlace.vue'),
			meta: {
				title: "考点刷题",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},
		{
			// 考点刷题
			path: '/testquset',
			name: 'testQuset',
			component: () => import('@/views/testQuset/index.vue'),
			meta: {
				title: "考点刷题",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},
		{
			// 考点刷题
			path: '/testquesttxt',
			name: 'testquesttxt',
			component: () => import('@/views/testQuset/testquesttxt.vue'),
			meta: {
				title: "",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{
			// 答题卡
			path: '/textcard',
			name: 'textCard',
			component: () => import('@/views/testQuset/textCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 随机刷题
			path: '/randomquest',
			name: 'randomQuest',
			component: () => import('@/views/randomQuest/index.vue'),
			meta: {
				title: "随机刷题",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},

		{
			// 答题卡
			path: '/randomcard',
			name: 'randomCard',
			component: () => import('@/views/randomQuest/randomCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true,
				appHeight: false
			}
		},
		{
			// 答题闯关
			path: '/passquest',
			name: 'passquest',
			component: () => import('@/views/passQuest/index.vue'),
			meta: {
				title: "答题闯关",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},

		{
			// 答题闯关题目
			path: '/passstartquset',
			name: 'passStartQuset',
			component: () => import('@/views/passQuest/passStartQuset.vue'),
			meta: {
				title: "",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 答题闯关-答题解析
			path: '/passanalysis',
			name: 'passanalysis',
			component: () => import('@/views/passQuest/passanalysis.vue'),
			meta: {
				title: "",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 答题闯关-解析答题卡
			path: '/passanalysiscard',
			name: 'passAnalysisCard',
			component: () => import('@/views/passQuest/passAnalysisCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},

		{   // 答题报告
			path: '/passreport',
			name: 'passReport',
			component: () => import('@/views/passQuest/passReport.vue'),
			meta: {
				title: "答题报告",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: false
			}
		},

		{   // 答题闯关-答题卡
			path: '/passcard',
			name: 'passcard',
			component: () => import('@/views/passQuest/passcard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: true
			}
		},

		{
			// 历年真题
			path: '/historyquset',
			name: 'historyQuset',
			component: () => import('@/views/historyQuset/index.vue'),
			meta: {
				title: "历年真题",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{
			// 套餐列表
			path: '/meal',
			name: 'meal',
			component: () => import('@/views/meal/index.vue'),
			meta: {
				title: "套餐列表",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{
			// 购买真题试卷
			path: '/buyMeal',
			name: 'buyMeal',
			component: () => import('@/views/buyMeal/index.vue'),
			meta: {
				title: "购买套餐",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{
			// 历年真题-我的练习
			path: '/historymytext',
			name: 'historyMyText',
			component: () => import('@/views/historyQuset/historyMyText.vue'),
			meta: {
				title: "我的练习",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},
		{
			// 历年真题-题目
			path: '/historyquest',
			name: 'historyQuest',
			component: () => import('@/views/historyQuset/historyQuest.vue'),
			meta: {
				title: "我的练习",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{   // 历年真题-答题卡
			path: '/historycard',
			name: 'historyCard',
			component: () => import('@/views/historyQuset/historyCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: true
			}
		},
		{   // 历年真题-答题报告
			path: '/historyreport',
			name: 'historyReport',
			component: () => import('@/views/historyQuset/historyReport.vue'),
			meta: {
				title: "答题报告",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: false
			}
		},
		{   // 历年真题-查看解析
			path: '/historyanalysis',
			name: 'historyAnalysis',
			component: () => import('@/views/historyQuset/historyAnalysis.vue'),
			meta: {
				title: "查看解析",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
			}
		},
		{
			// 答题卡
			path: '/historyanalycard',
			name: 'historyAnalyCard',
			component: () => import('@/views/historyQuset/historyAnalyCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 模拟考试
			path: '/imitatequest',
			name: 'imitateQuest',
			component: () => import('@/views/imitateQuest/index.vue'),
			meta: {
				title: "模拟考试",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 模拟考试-我的考试
			path: '/inmitstratquset',
			name: 'inmitStratQuset',
			component: () => import('@/views/imitateQuest/inmitStratQuset.vue'),
			meta: {
				title: "我的考试",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},
		{   // 模拟考试-答题报告
			path: '/imitreport',
			name: 'imitReport',
			component: () => import('@/views/imitateQuest/imitReport.vue'),
			meta: {
				title: "答题报告",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: false
			}
		},

		{   // 模拟考试-查看解析
			path: '/imitanalysis',
			name: 'imitAnalysis',
			component: () => import('@/views/imitateQuest/imitAnalysis.vue'),
			meta: {
				title: "查看解析",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
			}
		},

		{
			// 答题卡
			path: '/inmitanalycard',
			name: 'inmitAnalyCard',
			component: () => import('@/views/imitateQuest/inmitAnalyCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},

		{
			// 答题卡
			path: '/inmitcard',
			name: 'inmitCard',
			component: () => import('@/views/imitateQuest/inmitCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},

		{
			// 我的练习
			path: '/imitmypract',
			name: 'imitMyPract',
			component: () => import('@/views/imitateQuest/imitMyPract.vue'),
			meta: {
				title: "我的练习",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},

		{
			// 模考大赛
			path: '/mideltest',
			name: 'midelTest',
			component: () => import('@/views/midelTest/index.vue'),
			meta: {
				title: "模考大赛",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 模考大赛-题目
			path: '/midestartquest',
			name: 'midestartquest',
			component: () => import('@/views/midelTest/midestartquest.vue'),
			meta: {
				title: "我的考试",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{   // 模考大赛-答题卡
			path: '/midecard',
			name: 'mideCard',
			component: () => import('@/views/midelTest/mideCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: true
			}
		},

		{   // 模考大赛-答题报告
			path: '/midereport',
			name: 'mideReport',
			component: () => import('@/views/midelTest/mideReport.vue'),
			meta: {
				title: "答题报告",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
				appHeight: false
			}
		},
		
		{   // 模考大赛-查看解析
			path: '/mideanalysis',
			name: 'mideAnalysis',
			component: () => import('@/views/midelTest/mideAnalysis.vue'),
			meta: {
				title: "查看解析",
				keepAlive: false,
				Backcolor: false, //设置背景色 默认白色
				noNavigation:true,  //设置导航
				showAppPaddB: true, //是否显示app标签的底部padding
			}
		},

		{
			// 模考大赛-答题卡
			path: '/mideanalycard',
			name: 'mideAnalyCard',
			component: () => import('@/views/midelTest/mideAnalyCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},

		{
			// 我的练习
			path: '/mymidepractice',
			name: 'myMidePractice',
			component: () => import('@/views/midelTest/myMidePractice.vue'),
			meta: {
				title: "我的练习",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},

		{
			// 我的积分
			path: '/integral',
			name: 'integral',
			component: () => import('@/views/integral/index.vue'),
			meta: {
				title: "我的积分",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false
			}
		},{  // 积分规则
			path: '/integralrule',
			name: 'integralrule',
			component: () => import('@/views/integral/integralrule.vue'),
			meta: {
				title: "积分规则",
				tab: 2,
				keepAlive: false,
				Backcolor:false,
				noNavigation:true,  //设置导航
				showAppPaddB: false,
				appHeight: true
			}
		},


		{
			// 我的错题
			path: '/mywrong',
			name: 'myWrong',
			component: () => import('@/views/myWrong/index.vue'),
			meta: {
				title: "我的错题",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 我的错题的题
			path: '/wrongquest',
			name: 'wrongQuest',
			component: () => import('@/views/myWrong/wrongQuest.vue'),
			meta: {
				title: "我的错题",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true,
				appHeight: false
			}
		},
		{
			// 我的错题
			path: '/reaction',
			name: 'reaction',
			component: () => import('@/views/myWrong/reaction.vue'),
			meta: {
				title: "错题反馈",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 我的错题-答题卡
			path: '/wrongcard',
			name: 'wrongCard',
			component: () => import('@/views/myWrong/wrongCard.vue'),
			meta: {
				title: "答题卡",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true,
				appHeight: false
			}
		},
		{
			// 个人信息
			path: '/personalinfo',
			name: 'personalInfo',
			component: () => import('@/views/personalInfo/index.vue'),
			meta: {
				title: "个人信息",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 个人信息
			path: '/exchangecode',
			name: 'exchangecode',
			component: () => import('@/views/exchangecode/index.vue'),
			meta: {
				title: "兑换码",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 兑换记录
			path: '/exchange',
			name: 'exchange',
			component: () => import('@/views/exchange/index.vue'),
			meta: {
				title: "兑换记录",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},
		{
			// 兑换详情
			path: '/exchangedetail',
			name: 'exchangeDetail',
			component: () => import('@/views/exchange/exchangeDetail.vue'),
			meta: {
				title: "兑换详情",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: true
			}
		},

		{
			// 兑换详情
			path: '/information',
			name: 'information',
			component: () => import('@/views/information/index.vue'),
			meta: {
				title: "接本资讯",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},{
			// 排行榜
			path: '/ranking',
			name: 'ranking',
			component: () => import('@/views/midelTest/ranking.vue'),
			meta: {
				title: "排行榜",
				keepAlive: false,
				Backcolor:true,
				noNavigation: true,
				showAppPaddB: false,
				appHeight: true
			}
		},{
			// 随机刷题题
			path: '/randomstartquest',
			name: 'randomstartquest',
			component: () => import('@/views/randomQuest/randomstartquest.vue'),
			meta: {
				title: "",
				keepAlive: false,
				Backcolor:false,
				noNavigation: true,
				showAppPaddB: true,
				appHeight: false
			}
		}
	]
})
//console.log(111222)
router.beforeEach((to, from, next) => {
	//存推荐人UID到缓存
	let geturl = window.location.href 
	let getqyinfo = geturl.split('?')[1] 
	let getqys = new URLSearchParams('?'+getqyinfo)
	let spread = getqys.get('spread') 
	if(spread > 0){
		localStorage.setItem('spread', spread)
	}
	console.log('推荐人到缓存1',spread)

	
	//console.log('to信息',to.query.mer_id)
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    // console.log(store)
  }
		// window.addEventListener('focusout', function() {
		// 	document.body.scrollTop = 0;
		// })
	if ( from.path === '/') {
	//   console.log('tofn')
		localStorage.setItem('url', location.href)
		getConfig() //该函数和之前一样，被单独提取出来了
	}
	
	document.body.scrollTop = document.documentElement.scrollTop = 0;
	
	if(localStorage.getItem('indexFlag') && to.fullPath == '/index'){
		router.options.routes[1].meta.alive = false
		localStorage.removeItem('indexFlag')
	} else {
		router.options.routes[1].meta.alive = from.fullPath != '/chooseexam'
	}
	if(localStorage.getItem('merFlag') && to.fullPath == '/member'){
	router.options.routes[7].meta.alive = false
		localStorage.removeItem('merFlag')
	} else {
	router.options.routes[7].meta.alive = true
	}
	console.log(from,'from.内容')
	console.log(to,'to.内容')
	let mer_id = to.query.mer_id
	//return
    //获取浏览器缓存的用户信息
    if(store.state.token){ //如果有就直接到首页咯
		if(store.state.if_class && store.state.className){
			if(to.path=='/login'){
				next('/index');//这种情况应该不会存在
			} else {
          		next();//原路径访问
			}
        
		} else {
				if(to.path=='/chooseexam'){ //如果是登录页面路径，就直接next()
					next();
				} else { //不然就跳转到登录;
					next('/chooseexam');
				}
		}
    } else {
		if(to.path=='/login'){ //如果是登录页面路径，就直接next()
				next();
		} else { //不然就跳转到登录;
			//next('/login');
			if(mer_id){
				to.query.mer_id = mer_id
				next({
					path:'/login',
					to: to.name,
					query: to.query
				})
			}else{
				next('/login');
			}
		}

    }

  
});


export default router
